import React, { Component, ReactNode } from 'react';
import './PermissionManager.scss';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { NotificationHelper } from '../../helpers/NotificationHelper';
import * as serviceWorker from '../../serviceWorker';

enum PermissionRequestType {
  NOTIFICATIONS,
}

interface PermissionManagerState {
  showModal: boolean;
  title?: string;
  body?: JSX.Element;
  requestType?: PermissionRequestType;
}

export class PermissionManager extends Component<any, PermissionManagerState> {
  state: PermissionManagerState = {
    showModal: false,
  };

  componentDidMount(): void {
    this.checkForMissingPermissions();
  }

  private checkForMissingPermissions(): void {
    // Notifications
    if (('Notification' in window) &&
        Notification.permission !== 'granted' &&
        Notification.permission !== 'denied') {
      this.setState({
        showModal: true,
        title: 'Meldingen ontvangen',
        body: <div>
          MijnTOPP wil je graag meldingen kunnen sturen, wanneer je ingelogd bent én wanneer je MijnTOPP niet gebruikt. Zo ben je altijd op
          de hoogte van bijvoorbeeld nieuwe berichten of afspraken.<br/>
          <br/>
          <strong>
            Als je op de knop hieronder drukt, zal je browser vragen om toestemming te krijgen voor het weergeven van notificaties.
            Klik daar op toestaan om meldingen te ontvangen op dit apparaat.
          </strong>
        </div>,
        requestType: PermissionRequestType.NOTIFICATIONS,
      });
    }
  }

  private requestNotifications(): void {
    // Callback structure is deprecated, but Safari doesn't support the promise variant yet
    Notification.requestPermission((permission) => {
      if (permission === 'granted') {
        /* eslint-disable @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, no-console */
        serviceWorker.registerPushService()
          .then(() => console.log('Push service registered.'))
          .catch(err => console.error('Registering push service failed:', err));
        /* eslint-enable */
        NotificationHelper.push(
          'Gelukt! Je ontvangt nu meldingen, ook als je niet actief bent in MijnTOPP.',
          { title: 'Meldingen ingesteld', duration: 8000 });
      } else {
        NotificationHelper.push(
          'Je hebt meldingen geweigerd. Je ziet meldingen nu alleen als je ingelogd bent in MijnTOPP. Let op: je mist dus mogelijk (belangrijke) berichten en afspraken van je behandelaar. Je kunt je meldingen alsnog inschakelen via de instellingen van je browser.',
          { title: 'Meldingen ingesteld', duration: 8000 });
      }
      this.handleClose();
    })
      .catch(e => {
        console.warn('Failed to request permission for notifications', e);
      });
  }

  handleConfirm = (type: PermissionRequestType|undefined): void => {
    switch (type) {
      case PermissionRequestType.NOTIFICATIONS:
        this.requestNotifications();
        break;
    }
  };

  handleClose = (): void => {
    this.setState({
      showModal: false,
      title: undefined,
      body: undefined,
      requestType: undefined
    });
  };

  render(): ReactNode {
    const { showModal, title, body, requestType } = this.state;
    return (
      <Modal
        show={showModal}
        onHide={this.handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {body}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => this.handleConfirm(requestType)}>
            Oké, ga door
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
